"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCumulativeDistancesKM = exports.isCheckpoint = void 0;
const isCheckpoint = (point) => Boolean(point.content);
exports.isCheckpoint = isCheckpoint;
// Cumulative distance in km from points[0] to points[i], for every i.
// The last entry is the total path length. Returns [] for < 1 points.
const getCumulativeDistancesKM = (walkMap) => {
    if (walkMap.points.length === 0) {
        return [];
    }
    const distances = [0];
    for (let i = 1; i < walkMap.points.length; i++) {
        const prev = walkMap.points[i - 1];
        const curr = walkMap.points[i];
        const segmentPx = Math.sqrt(Math.pow(curr.x - prev.x, 2) + Math.pow(curr.y - prev.y, 2));
        distances.push(distances[i - 1] + segmentPx * walkMap.pxToKM);
    }
    return distances;
};
exports.getCumulativeDistancesKM = getCumulativeDistancesKM;
